export function removeAssignment(state, options) {
    const { id, atomID = '', axis } = options;
    let atomIDs = state.assignments?.[id]?.[axis] || null;
    if (atomIDs) {
        if (atomID) {
            atomIDs = atomIDs.filter((id) => id !== atomID);
            state.assignments[id][axis] = atomIDs;
        }
        else {
            state.assignments[id][axis] = [];
        }
    }
}
export default function removeAssignments(state, action) {
    const newState = {
        ...state,
    };
    // signal id
    const { ids, atomID = '', axis } = action;
    for (const id of ids) {
        removeAssignment(newState, { id, atomID, axis });
    }
    return newState;
}
